import { User, UserSettings } from '@/lib/types'
import { systemPrompt, conversationalModePrompt, searchModePrompt, quickQuestionModePrompt } from '@/lib/user/system-prompt'
import { FREE_MODEL_ID } from '../models/model-tiers'


export const defaultSettings: UserSettings = {
    favoriteModels: [],
    systemPrompt: systemPrompt,
    defaultTextModel: 'openrouter:google/gemini-2.5-flash',
    // defaultTextModel: 'openrouter:openai/gpt-5-nano',
    defaultImageModel: 'fal-ai/imagen4/preview',
    maxWidth: 800,
    sendOn: "enter",
    modelToLoad: "default",
    subModes: [
        {
            label: 'Conversational',
            modelId: 'openrouter:openai/gpt-4o',
            systemPrompt: conversationalModePrompt,
            type: 'text',
            description: 'Curious, back-and-forth dialogue'
        },
        {
            label: 'Quick Question',
            modelId: 'openrouter:google/gemini-2.5-flash',
            systemPrompt: quickQuestionModePrompt,
            type: 'text',
            description: 'One concise answer'
        },
        {
            label: 'Search',
            modelId: 'perplexity/sonar',
            systemPrompt: searchModePrompt,
            type: 'text',
            description: 'Source-backed answers'
        }
    ]
}


export const defaultUser: User = {
    id: '68075bf6-1398-4159-b4a9-2aa61c7e6aef',
    createdAt: '2025-03-16 06:03:52.910676+00',
    displayName: 'guest User',
    username: 'guest-user',
    firstName: '',
    lastName: '',
    email: 'guest@guest.com', // DO NOT @TRYBLEND.AI EMAIL AS MIGHT GIVE ADMIN ACCESS
    imageUrl: '',
    balance: 0,
    subscription: 'free',
    role: 'guest',
    settings: defaultSettings
}


